/**
 * Test IDs for QA automation.
 */
export const testIds = {
  documentFormDocumentLabelPicker: "document-form-document-label-picker",
  documentFormDocumentLabelSearch: "document-form-document-label-search",
} as const;
